(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["faq-collection"] && !window.DesignMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', function () {
  // Select all FAQ buttons
  var faqButtons = document.querySelectorAll('.faq-toggle');
  
  // Loop through each FAQ button
  faqButtons.forEach(function(faqButton, index) {
    // Get the associated answer div
    var answerId = faqButton.getAttribute('aria-controls');
    var answer = document.getElementById(answerId);
    var icon = faqButton.querySelector('.faq-icon');
    
    // If it's the first FAQ, open it by default
    if (index === 0) {
      answer.style.display = 'block';
      faqButton.setAttribute('aria-expanded', 'true');
      icon.textContent = '−';  // Change to minus on load
    } else {
      answer.style.display = 'none';
      faqButton.setAttribute('aria-expanded', 'false');
      icon.textContent = '+';  // Keep plus when closed
    }

    // Add click event for toggling FAQ
    faqButton.addEventListener('click', function () {
      var expanded = faqButton.getAttribute('aria-expanded') === 'true';

      // Toggle visibility of the answer
      if (expanded) {
        answer.style.display = 'none';
        faqButton.setAttribute('aria-expanded', 'false');
        icon.textContent = '+';  // Change to plus on close
      } else {
        answer.style.display = 'block';
        faqButton.setAttribute('aria-expanded', 'true');
        icon.textContent = '−';  // Change to minus on open
      }
    });
  });
});


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mobile-search-bar"] && !window.DesignMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', function() {
  const searchWrapper = document.querySelector('.mobile-search-bar-wrapper');
  const header = document.querySelector('header');
  
  if (searchWrapper && header) {
    // Get the header height
    const headerHeight = header.offsetHeight;
    
    // Set initial position below header
    searchWrapper.style.position = 'sticky';
    searchWrapper.style.top = headerHeight - 2 + 'px';
    searchWrapper.style.left = '0';
    searchWrapper.style.right = '0';
    
    // Add scroll event listener
    let lastScroll = 0;
    window.addEventListener('scroll', () => {
      const currentScroll = window.pageYOffset;
      
      if (currentScroll > headerHeight) {
        // When scrolled past header, position it below header with minimal gap
        searchWrapper.style.position = 'fixed';
        searchWrapper.style.top = headerHeight - 2 + 'px';
        searchWrapper.style.left = '0';
        searchWrapper.style.right = '0';
      } else {
        // When not scrolled past header, keep it below header with minimal gap
        searchWrapper.style.position = 'sticky';
        searchWrapper.style.top = headerHeight - 2 + 'px';
        searchWrapper.style.left = '0';
        searchWrapper.style.right = '0';
      }
      
      lastScroll = currentScroll;
    });
  }
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-list"] && !window.DesignMode) return;
  try {
    
    document.addEventListener('DOMContentLoaded', () => {
      const applyAccordionState = () => {
        const showAccordionOnMobile =
          document.querySelector('[data-show-accordion]')?.getAttribute('data-show-accordion') === 'true';
        const isMobile = window.matchMedia('(max-width: 767px)').matches;
        document.querySelectorAll('details[data-accordion]').forEach((el) => {
          if (showAccordionOnMobile && isMobile) {
            // Show accordion on mobile if setting allows
            el.removeAttribute('open', '');
            document.querySelector('[data-show-accordion]').setAttribute('data-show-accordion','false');
          } else if (!showAccordionOnMobile && isMobile) {
            // Do not show accordion on mobile if setting disallows
           // el.setAttribute('open');
          } else if (!isMobile) {
            // On desktop, always open accordions
            el.setAttribute('open', '');
            document.querySelector('[data-show-accordion]').setAttribute('data-show-accordion','true');
          }
        });
      };
      applyAccordionState();
      window.addEventListener('resize', applyAccordionState);
      document.addEventListener('shopify:section:load', (event) => {
        // Apply accordion state when a new section is loaded
        applyAccordionState();
      });
    });
  
  } catch(e) { console.error(e); }
})();
})();
